import React, { useContext, useEffect, useRef } from 'react';
import gsap from 'gsap';

import { UIContext } from 'context/ui';
import Logotype from 'assets/svg/logotype.svg';

import { LanguageControl } from 'components/language-control/LanguageControl';
import { Link } from 'components/link/Link';
import { SearchButton } from 'components/search-button/SearchButton';

import s from './Header.scss';
import { useIntl } from 'react-intl';

interface IHeaderProps {
  children?: React.ReactNode; // BackButton always?
  logo?: boolean; // usually no children if there is a logo
}

export const Header = ({ children, logo = true }: IHeaderProps) => {
  const {
    isDesktop,
    isHomepage,
    homepageLoaded,
    homepageAnimationComplete,
    setHomepageAnimationComplete,
} = useContext(UIContext);
  const navRef = useRef<HTMLUListElement>(null);

  const intl = useIntl();

  useEffect(() => {
    if (!navRef.current) {
      return;
    }

    if (homepageLoaded && isDesktop) {
      const t = gsap.timeline({ onComplete: () => setHomepageAnimationComplete(true), paused: true });
      t.to(navRef.current.childNodes, {
        y: 0,
        autoAlpha: 1,
        stagger: 0.15,
        duration: 0.5,
        delay: 0.2,
      });

      if (homepageAnimationComplete) {
        t.seek(t.duration()).play();
      } else {
        t.play();
      }
    }
  }, [homepageLoaded, isDesktop]);

  return (
    <div className={s('header', { hasLogo: logo })}>
      <div className={s.header__container}>
        {children}

        {logo && (
          <Link className={s.header__link} to="/">
            <Logotype className={s.header__logo} />
          </Link>
        )}

        <ul ref={navRef} className={s('header__nav', { isHomepage })} aria-hidden={!isDesktop}>
          {/* should be new component */}
          <li className={s.header__navItem}>
            <LanguageControl />
          </li>
          <li className={s.header__navItem}>
            <SearchButton>
              {intl.formatMessage({ id: 'header.search', defaultMessage: 'Leit' })}
            </SearchButton>
          </li>
        </ul>
      </div>
    </div>
  );
};
